import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe         } from '../../Components/UI/UI'

import {    newPosts  } from "../../Data/Data";
import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./EilatNegevPage.css"

class EilatNegevPage extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

 componentDidMount () {
   
    Promise.all([ asyncgetWeather() ]).then( response => {
      const weather = response[0];
        // console.log( typeof weather);
      // console.log( weather);
    
      var weather2 = weather;

      
      if (typeof weather === 'string' && weather.includes("float")) {
        // Variable is a string
        // console.log('Is float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);

      
      } else if (typeof weather === 'object' && weather !== null) {
        // Variable is an object
        // console.log('Variable is an object');
        weather2 = weather.data;
        // console.log(weather2);
       
      } else if (typeof weather === 'string' && !weather.includes("float")){
        // console.log('Is NOt  float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);
     
      }

      //  else {
      //   // Variable is neither a string nor an object
      //   console.log('Variable is neither a string nor an object');
      // }

      this.setState({ 
        deadSeaWeather: weather2.deadsea.temperature,
        jerusalemWeather: weather2.jerusalem.temperature,
        telAvivWeather: weather2.telaviv.temperature,
        waterTemp: weather2.telaviv.water_temp,
      });
    });
  
    window.addEventListener("resize", this.updateDimensions);
  }
  


  render(){
    // get all posts 
    const  posts = [ ...newPosts ] ;

    // get non video posts and culinary posts
    const eilatnegevPosts = posts.filter((o , i )=>{
       return o.ctg === 'eilat-negev' && o.isDouble !== true;
    })

    // const thingsToDoPosts = [ ...posts ];


    const postsHtml = eilatnegevPosts.map( (o,i) => {
        // console.log('o' , o);
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;
        
        if (o.isVid === true) {
         
          url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
          component = <VideoSliderItem  
                        key={i}
                        title={o.title}
                        desc={""}
                        img= {o.img}
                        link={url}
                        cssClass={cssClass} />
        }else {
          // url = "/Posts/" + o.id ;
          url  = "/Posts/" + o.ctg  + '/' + o.id;
          component = <PostSliderItem  
                          key={i}
                          title={o.title}
                          desc={""}
                          img= {o.img}
                          link={url}
                          cssClass={cssClass} />
        }

        return component;
        
    });

    return(
      <div className="inner-page align-center page-eilatnegev">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
            NEGEV UND EILAT
            </HomeTitle>
            <ResponsiveYouTubeIframe vidId={"ZdnNT-GDJv4"} />
            <div className="live-shows-wrapper">
              {postsHtml}
             
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default EilatNegevPage


// WEBPACK FOOTER //
// ./src/Pages/EilatNegevPage/EilatNegevPage.js